// Bugsnag must load before any other app code so its global error /
// unhandledrejection hooks register first. In dev it's a no-op and
// BugsnagErrorBoundary is a pass-through fragment.
import { BugsnagErrorBoundary } from "./lib/bugsnag";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { BASE_PATH } from "./lib/base-path";
import { App } from "./App";
import "./styles/index.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element #root not found");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <BugsnagErrorBoundary>
      <BrowserRouter basename={BASE_PATH}>
        <App />
      </BrowserRouter>
    </BugsnagErrorBoundary>
  </React.StrictMode>,
);
